import { render, staticRenderFns } from "./driverList.vue?vue&type=template&id=40547c12&scoped=true&"
import script from "./driverList.vue?vue&type=script&lang=js&"
export * from "./driverList.vue?vue&type=script&lang=js&"
import style0 from "./driverList.vue?vue&type=style&index=0&id=40547c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40547c12",
  null
  
)

export default component.exports